import { BaseEntity } from "./BaseEntity";
import { School } from "./School";

export class SchoolBatch extends BaseEntity {
    public name: string = "";
    public school: string | School = "";

    constructor(model: Partial<SchoolBatch> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PSchoolBatch = Partial<SchoolBatch>;
